/**
 * Contient les fonctions algolia commune utilisé par les blocs tematik_recette et tematik_produits
 */


/**
 * 
 * tematik_produit & tematik_recette
 */

/**
 * Permet de garder le contenu des filtres algolia lors d'un changement de page
 * Retourne le router à passer en parametre à instantsearch: routing
 * @param {string} indexName, nom de l'index d'algolia
 * @return {object}
 */
export function getCustomRouter(indexName)
{
    // le nom du cookie est unique sur chaque page
    let cookieName = indexName + "_"  + getPageId();

    let router = { 
        router: {
            /**
             * Lis la valeur du cookie pour mettre à jour les filtres Algolia.
             * 
             * Ne lis pas le cookie si une requet post à été faite, 
             * on lira la requet post geré via le parametre initialUiState de instantsearch à la place
             * @see https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/#widget-param-routing
             * @see https://developer.mozilla.org/en-US/docs/Web/API/document/cookie#example_2_get_a_sample_cookie_named_test2
             */
            read() {
                if(postRequestExist() == 0){
                    const cookieValue = document.cookie
                    .split('; ')
                    .find(row => row.startsWith(`${cookieName}=`))
                    ?.split('=')[1];
                    const cookieSafeValue =
                        typeof cookieValue === 'undefined'
                        ? {}
                        : JSON.parse(decodeURIComponent(cookieValue));
    
                    return cookieSafeValue;
                }
            },
            /**
             * Stocke les filtres dans un cookie.
             * @see https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/#widget-param-routing
             * @param {*} routeState
             */
            write(routeState) {
                // On mets à jour l'URL si l'utilisateur coche un paramètre
                window.history.replaceState({}, document.title, window.location.href.split("?")[0]);
                const cookieValue = `${cookieName}=${encodeURIComponent(JSON.stringify(routeState))}; SameSite=Strict`
                document.cookie = cookieValue;
            },
            onUpdate() {},
            createURL() {}
        },
    }

    return router
}


/**
 * Les identifiantsAPI
 * permet de recupérer les appID et apiID
 */
export function getApiIdentifiant()
{
    let algoliaAppId = $('.tematik_list_algolia').data('algolia-app-id');
    let algoliaApiId = $('.tematik_list_algolia').data('algolia-api-id');

    if (algoliaAppId.length === 0 || algoliaAppId.length === 0) return null;

    return {
        "appId": algoliaAppId,
        "apiId": algoliaApiId
    }
}

/**
 * Retourne les filtres sélectionnés dans les paramètres de bloc sous forme d'objet
 * @return {string} filtres
 */
export function getFiltres()
{
    let filtres = $('.tematik_list_algolia').data('filtres');
    return filtres;
}

/**
 * Retourne les filtres définis dans la barre de recherche du dashboard sous forme d'objet
 * @return {string} searchFiltres
 */
export function getSearchFiltres()
{
    let searchFiltres = $('.tematik_list_algolia').data('search-filtres');
    return searchFiltres;
}

/**
 * @return {string}
 */
export function getPageId()
{
    let pageId = $('.tematik_list_algolia').data('page-id');

    if (pageId === 0) return null;
    return pageId;
}

export function postRequestExist()
{
    return $('.tematik_list_algolia').data('post-request');
}


/**
 * Tematik recette
 */

/**
 * Récupère les ingrédients saisis et celui en cours de saisis (dans l'input)
 */
export function getAllIngredientValues()
{
    let tabElement = [];
    $('.wrapper span').each(function(e) {
        let value = $(this).text()
        tabElement.push(value);
    });

    return tabElement;
}

/**
 * Retourne la valeur du champs de recherche
 */
export function getSearchInputValue()
{
    return $('#inputBarreVisible').val();
}